module.exports = __webpack_public_path__ + "img/dsci0091.1b1300de.jpg";